import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';

export interface WarningMessage {
    header: string;
    message: string;
    actionText?: string;
    confirmText: string;
    resolveCb?: Function;
    buttonLayout?: 'row' | 'column';
}

export interface WarningState {
    currentWarning: WarningMessage | null;
}

export const warningState: Writable<WarningState> = writable({
    currentWarning: null,
});

type ShowConfirmWarning = Pick<
    WarningMessage,
    Exclude<keyof WarningMessage, 'resolveCb'>
>;

export async function showConfirm(
    warningMessage: ShowConfirmWarning,
): Promise<boolean> {
    return new Promise((resolve) => {
        warningState.set({
            currentWarning: { ...warningMessage, resolveCb: resolve },
        });
    });
}
